import { combineReducers } from 'redux';

import auth from './auth';

import dwelling from './dwelling';
import dwellings from './dwellings';

import statistics from './statistics';
import bbr from './bbr';

import org from './organizations';
import i18n from './i18n';

import app from 'app/layout/redux';
import activity from 'app/activity/redux';
import users from 'app/users/redux';

export default combineReducers({
  app,
  auth,
  i18n,
  dwelling,
  dwellings,
  org,
  bbr,
  users,
  activity,
  statistics,
});
